import React from "react";

import { Grid } from "@material-ui/core";
import ControlTimer from "./Timer";
import ContainerMode from "./ContainerMode";
import StateControl from "./State";
import VsScreenSettings from "./VsScreenSettings";

const StatePage = () => {
  return (
    <div>
      <Grid container spacing={6}>
        <Grid item sm={12} md={12} lg={6} style={{ padding: 20 }}>
          <ContainerMode />
        </Grid>
        <Grid item sm={12} md={12} lg={6} style={{ padding: 20 }}>
          <VsScreenSettings />
        </Grid>
        <Grid item sm={12} md={6} lg={6} xl={3} style={{ padding: 20 }}>
          <ControlTimer />
        </Grid>
        <Grid item sm={12} md={6} lg={6} xl={3} style={{ padding: 20 }}>
          <StateControl />
        </Grid>
      </Grid>
    </div>
  );
};

export default StatePage;
